module.exports = __webpack_public_path__ + "img/whatsapp_back.026b3833.png";